import { render, staticRenderFns } from "./Docs.vue?vue&type=template&id=c6f753fc&scoped=true"
import script from "./docs.js?vue&type=script&lang=js&external"
export * from "./docs.js?vue&type=script&lang=js&external"
import style0 from "./docs.scss?vue&type=style&index=0&id=c6f753fc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f753fc",
  null
  
)

export default component.exports